export const dynamicConfig = dynamicEnvironmentURLs => ({
  API: {
    ROOT_URL: () => dynamicEnvironmentURLs.apiBaseURL,
    IE_ROOT_URL: () => `${dynamicEnvironmentURLs.webappURL}/cors`,
    SUBMISSION_URL: () => `${dynamicEnvironmentURLs.webappURL}/api/consultation/submitsession`,
    POSTCODE_URL: (practiceId, postcode) => `${dynamicEnvironmentURLs.webappURL}/findMatchingPostcodes/${postcode}`,
    ADDRESSES_URL: (practiceId, postcode) => `${dynamicEnvironmentURLs.webappURL}/searchPostcode/${postcode}`,
  },
});
